module.exports = __webpack_public_path__ + "img/kt-zr.a164a7cf.png";